import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { NgxPermissionsModule } from 'ngx-permissions';
import { routes } from './app.routes';
import { AppTranslateModule } from './core/modules/translate/app-translate.module';
import { AuthService } from './core/services/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideToastr(),
     provideRouter(routes),
     provideHttpClient(),
     importProvidersFrom(NgxPermissionsModule.forRoot()),
     importProvidersFrom(AppTranslateModule.forRoot()),
     provideAppInitializer(() => {
      return inject(AuthService).loadPermissions();
    })
    ]
};
